import { useEffect, useState } from 'react'
import { WorkContext } from 'utils/getContext'
import { Collapse, Checkbox, Space } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
import { getPersonalDetailValue } from 'api/api'
import notAvailable from 'static/images/notAvailable.png'
import dropDown from 'static/images/dropDown.png'
import dropDownC from 'static/images/dropDownC.png'
import { TRUE_FLAG_NUM, FALSE_FLAG_NUM } from 'utils/constant'

const DissatisfyItem = () => {
  const navigate = useNavigate()
  /**
   * 处理title显示
   * @param {*} name  事项名称
   * @returns  
   */
  const handleTitle = (name) => {
    return (
      <div className="item-title">
        <img src={notAvailable} alt="不可办理" />
        {name}
      </div>
    )
  }

  // 处理requirements显示
  const handleRequirements = (requirements) => {

    if (!requirements || requirements.length === 0) return null

    // 处理condition的点击事件
    const handleCondition = (item) => {
      const { fhandle: name, issuesid: id } = item
      const newItem = {
        name,
        id
      }
      navigate('/conditionCheck', { state: { item: newItem } })
    }

    const handleContent = (condition) => {
      if (!condition) return null
      return condition.map((item) => {
        const { errorMsg, handle, id, value } = item
        if (value === TRUE_FLAG_NUM) return null
        if (value === FALSE_FLAG_NUM) {
          return (
            <div className="dissatisfy-right-item" key={id}>
              <p>{errorMsg}</p>
              {
                handle && (
                  <p onClick={() => handleCondition(item)}>
                    请点击办理：
                    <span className='link'>{handle}</span>
                  </p>
                )
              }
            </div>
          )
        }
        return null
      })
    }

    const ConditionItem = ({ item }) => {

      const [newItem, setNewItem] = useState(item)

      useEffect(() => {
        const { determine, conditionItem } = item || {}
        getPersonalDetailValue(conditionItem, determine).then(res => {
          const { data } = res || {}
          const { value, conditions } = data || {}
          if (!value || !conditions) return
          let newItems = item
          newItems.condition = conditions
          newItems.value = value
          setNewItem(newItems)
        })
      }, [item])

      const { value, condition: conditions } = newItem || {}

      const check = value === TRUE_FLAG_NUM

      return (
        <div className="item-content-item-content">
          <Space >
            <Checkbox checked={check} disabled /> 是
            <Checkbox checked={!check} disabled /> 否
          </Space>
          <div className="item-content-right">
            {handleContent(conditions)}
          </div>
        </div>
      )
    }
    return requirements.map((item, index) => {
      const { requirement, id } = item
      return (
        <div key={id || index} className="item-content-item">
          <div className="item-content-item-title">{requirement}</div>
          <ConditionItem item={item} />
        </div>
      )
    })
  }


  return (
    <WorkContext.Consumer>
      {value => {
        const { dissatisfyList } = value
        if (!dissatisfyList || dissatisfyList.length === 0) return null
        return (
          <div className="recommend-item">
            <div className="recommend-item-title">您暂不满足以下事项的申请条件，请点击展开查看详细原因：</div>
            <Collapse
              className="list"
              defaultActiveKey={['1']}
              arrow={active => (active ? <img src={dropDownC} alt="上收" /> : <img src={dropDown} alt="下拉" />)}
            >
              {dissatisfyList.map(item => {
                const { id, name, requirements } = item
                return (
                  <Collapse.Panel key={id} title={handleTitle(name)}>
                    <div className="item-content">
                      {handleRequirements(requirements)}
                    </div>
                  </Collapse.Panel>
                )
              })
              }
            </Collapse>
          </div>
        )
      }
      }
    </WorkContext.Consumer>
  )
}

export { DissatisfyItem }